module.exports = __webpack_public_path__ + "img/4.b13a78ed.png";